module.exports = __webpack_public_path__ + "img/p1.79daf8e6.png";